import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, SendIcon } from 'lucide-react';
import { SITE } from '../lib/site';
interface Props {
  compact?: boolean;
}
export function QuoteForm({
  compact = false
}: Props) {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    zip: '',
    details: ''
  });
  const update = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(f => ({
    ...f,
    [key]: e.target.value
  }));
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  if (submitted) {
    return <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="flex flex-col items-center gap-3 rounded-xl border border-jk-red/40 bg-jk-panel p-8 text-center" data-id="element-100" data-mp="2xuxspuqp37la">
        <CheckCircle2Icon className="h-12 w-12 text-jk-red" data-id="element-101" data-mp="36wf4j0x2kn46" />
        <h3 className="font-display text-2xl font-bold uppercase text-white" data-id="element-102" data-mp="3gnqd6dewm4az">You're on the list, {form.name || 'friend'}!</h3>
        <p className="text-white/65" data-id="element-103" data-mp="3lm1luktgq8rm">
          A King will call you back fast. Need it hauled today? Ring us at{' '}
          <a href={SITE.phoneHref} className="font-semibold text-jk-red" data-id="element-104" data-mp="3ql4sg9p3cn1p">{SITE.phoneDisplay}</a>.
        </p>
      </motion.div>;
  }
  const field = 'w-full rounded-lg border border-white/15 bg-black/40 px-4 py-3 text-white placeholder-white/40 outline-none transition-colors focus:border-jk-red';
  return <form onSubmit={onSubmit} className="rounded-xl border border-white/10 bg-jk-panel p-5 sm:p-6" data-id="element-105" data-mp="8eqalznpbsy1">
      {!compact && <h3 className="mb-1 font-display text-2xl font-bold uppercase text-white" data-id="element-106" data-mp="d9dsvgs43r46">Get a free estimate</h3>}
      {!compact && <p className="mb-4 text-sm text-white/55" data-id="element-107" data-mp="m87x9tboplsa">Tell us what to haul — we'll call you right back.</p>}
      <div className={`grid gap-3 ${compact ? '' : 'sm:grid-cols-2'}`} data-id="element-108" data-mp="r69ee8pjvb14">
        <input required value={form.name} onChange={update('name')} className={field} placeholder="Your name" aria-label="Your name" data-id="element-109" data-mp="r4g50lnjycpf" />
        <input required value={form.phone} onChange={update('phone')} className={field} placeholder="Phone number" type="tel" aria-label="Phone number" data-id="element-110" data-mp="2j952tek2smd2" />
      </div>
      <input value={form.zip} onChange={update('zip')} className={`${field} mt-3`} placeholder="Zip code" aria-label="Zip code" data-id="element-111" data-mp="2x1l7ejsmksg3" />
      <textarea value={form.details} onChange={update('details')} rows={compact ? 2 : 3} className={`${field} mt-3 resize-none`} placeholder="What needs hauling? (couch, garage cleanout, hot tub…)" aria-label="What needs hauling" data-id="element-112" data-mp="36x5438f0jv5w" />
      <button type="submit" className="mt-4 flex w-full items-center justify-center gap-2 rounded-lg bg-jk-red px-5 py-3.5 font-display text-xl font-bold uppercase tracking-wide text-white transition-transform hover:scale-[1.02] hover:bg-jk-redDark" data-id="element-113" data-mp="3azrq2sp06lv6">
        <SendIcon className="h-5 w-5" data-id="element-114" data-mp="1gnv3bd1ia46g" /> Get My Free Quote
      </button>
      <p className="mt-3 text-center text-xs text-white/40" data-id="element-115" data-mp="3s9drez7nlg0e">No obligation · Free estimates · We call you back fast</p>
    </form>;
}